import React from 'react';

import EditSightingForm from '../Forms/EditSighting';

const EditSighting = () => {

  return (
    <>
      <h3 className="modal__header">Edit Sighting</h3>

      <EditSightingForm />
    </>
  );

}

export default EditSighting;